<app-layout [isIframe]="isIframe" />
